<script>
  export let friend;
</script>

<style>
  .friend {
    color: #00005c;
    padding: 10px;
    font-family: "Roboto Slab", serif;
    font-size: 20px;
    font-weight: bold;
  }
</style>

<div class="friends-list">
  <div class="friend">{friend.name}</div>
</div>
